import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom-v5-compat';

import { useFeatureToggle } from '~/platform/utilities/feature-toggles';
import { DEFAULT_CLAIM_TAB } from '../../constants';
import { searchWithTab } from '../../utils/appeals-v2-helpers';

// Catch-all for unknown /your-claims/:id/* subpaths (typos, stale bookmarks)
// that no defined route matches. Recovers to the claim's default view instead
// of the blank page these URLs render today. The flag only changes the URL
// shape: ?tab=status when on, the legacy /status route when off. Either way
// any other query params are preserved.
export default function ClaimSubpathRedirect() {
  const { useToggleValue, TOGGLE_NAMES } = useFeatureToggle();
  const useVaTabs = useToggleValue(TOGGLE_NAMES.cstClaimDetailsVaTabs);
  const { id } = useParams();
  const { search } = useLocation();

  const to = useVaTabs
    ? `/your-claims/${id}${searchWithTab(search, DEFAULT_CLAIM_TAB)}`
    : `/your-claims/${id}/${DEFAULT_CLAIM_TAB}${search}`;
  return <Navigate to={to} replace />;
}
